export default "__VITE_ASSET__BT4bGG0v__"